<template>
    <div>
        <SearchBox ref="SearchBox">
            <el-form slot="form" :inline="true" ref="searchParams" :model="searchParams" label-width="80px" class="unitWidth" size="small">
                <el-form-item label="操作模块">
                    <el-select v-model="operationModel" placeholder="请选择" filterable clearable @change="getSysOperationLogList">
                        <el-option label="用户" value="sys_user"></el-option>
                        <el-option label="角色" value="sys_role"></el-option>
                        <el-option label="车间" value="sys_workshop"></el-option>
                        <el-option label="工段" value="sys_worksection"></el-option>
                        <el-option label="产线" value="sys_line"></el-option>
                        <el-option label="班次" value="sys_shift"></el-option>
                        <el-option label="枚举类型" value="sys_enum_type"></el-option>
                        <el-option label="计划保养" value="plan_maintain_order"></el-option>
                        <el-option label="能力检测" value="ability_detectn_item"></el-option>
                        <el-option label="工装台账" value="tooling"></el-option>
                        <el-option label="工装分类" value="tooling_classify"></el-option>
                        <el-option label="备件台账" value="spare_part"></el-option>
                        <el-option label="备件分类" value="spare_part_classify"></el-option>
                        <el-option label="仓库" value="spare_part_storehouse"></el-option>
                        <el-option label="库位" value="spare_part_position"></el-option>
                        <el-option label="备件入库" value="spare_part_purchase_order"></el-option>
                        <el-option label="备件出库" value="spare_part_delivery_order"></el-option>
                        <el-option label="安灯规则" value="andon_rule"></el-option>
                        <el-option label="安灯工单" value="andon_order"></el-option>
                        <el-option label="安灯种类" value="andon_content"></el-option>
                        <el-option label="其它" value="other"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="操作类型">
                    <el-select v-model="operationType" placeholder="请选择" filterable clearable @change="getSysOperationLogList">
                        <el-option label="保存" value="ins"></el-option>
                        <el-option label="修改" value="upd"></el-option>
                        <el-option label="删除" value="del"></el-option>
                        <el-option label="其它" value="other"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="日期">
                    <el-date-picker
                        style="width: 50vh"
                        value-format="yyyy-MM-dd"
                        v-model="dateRange"
                        type="daterange"
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期" @change="getSysOperationLogList">
                    </el-date-picker>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="getSysOperationLogList">查询</el-button>
                </el-form-item>
            </el-form>
        </SearchBox>
        <LabelContent title="日志列表" ref="LabelContent">
        </LabelContent>
        <div class="tableBox">
            <el-table stripe ref="multipleTable" :data="tableData" class="center" @selection-change="handleSelectionChange" @sort-change="sortChange">
                <el-table-column prop="fcName" sortable label="工厂" show-overflow-tooltip />
                <el-table-column prop="userName" sortable label="操作用户" show-overflow-tooltip />
                <el-table-column prop="operationModel.desc" sortable label="操作模块" show-overflow-tooltip />
                <el-table-column prop="operationType.desc" sortable label="操作类型" show-overflow-tooltip />
                <el-table-column prop="operationDesc" sortable label="操作内容" show-overflow-tooltip />
                <el-table-column prop="createTime" sortable label="操作时间" show-overflow-tooltip />
            </el-table>
        </div>
        <el-pagination
            @size-change="paginationChange"
            @current-change="paginationCurrentChange"
            :current-page="searchParams.page"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="searchParams.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="searchParams.pageCount"
        />
    </div>
</template>

<script>
    import moment from 'moment'

    export default {
        name: 'allLog',
        data(){
            return{
                searchParams: {
                    pageSize: 10,
                    page: 1,
                    pageCount: 0
                },
                tableData: [],
                userInfo: {},
                dateRange: [],
                operationModel: '',
                operationType: ''
            }
        },
        created() {
            this.init()
        },
        methods:{
            init(){
                this.userInfo = this.$store.state.userInfo
                this.getSysOperationLogList()
            },
            //多选框选择 返回当前已选行数据(Array)
            handleSelectionChange(val) {
                console.log(val)
            },
            //从后台获取数据,重新排序
            sortChange(val) {
                // 详细文档参考： https://element.eleme.cn/2.13/#/zh-CN/component/table
                console.log(val)
            },
            //分页
            paginationChange(val) {
                this.searchParams.pageSize = val
                this.getSysOperationLogList()
            },
            paginationCurrentChange(val){
                this.searchParams.page = val
                this.getSysOperationLogList()
            },
            getSysOperationLogList () {
                let params = {
                    pageSize: this.searchParams.pageSize,
                    pageNum: this.searchParams.page
                }
                let userInfo = JSON.parse(sessionStorage.getItem("userInfo"))
                let str = ''
                if (this.userInfo.factoryId != 0) {
                    for (let i = 0; i < userInfo.roles.length; i++) {
                        str += userInfo.roles[i].fcCode + ','
                    }
                    str = str.substring(0, str.length - 1)
                    params['fcCode'] = str
                }
                let self = this
                if (self.dateRange != null && self.dateRange != '') {
                    if (self.dateRange.length > 0 && self.dateRange[0] != '') {
                        params['startTime'] = self.dateRange[0] + ' 00:00:00'
                        params['endTime'] = self.dateRange[1] + ' 23:59:59'
                    }
                }
                if (self.operationModel != undefined && self.operationModel != '') {
                    params['operationModel'] = this.operationModel
                }
                if (self.operationType != undefined && self.operationType != '') {
                    params['operationType'] = self.operationType
                }
                let options = {
                    method: 'get',
                    url: this.$api.sysOperationLogList,
                    params: params
                }
                this.$http.request(options).then(response => {
                    if (response.status == 100) {
                        this.tableData = response.data.list
                        this.searchParams.pageCount = response.data.total
                    }
                })
            }
        }
    }
</script>

<style scoped>

</style>
